<template>
  <ValidationProvider v-slot="{ errors }" class="lv-upload-img-list" :rules="rules">
    <input type="hidden" :value="images" />
    <div class="lv-upload-img-list__title-wrap">
      <LvText v-if="title" h6 bold>
        {{ $t(title) }}
        <LvText v-if="required" h6 red bold>*</LvText>
      </LvText>
      <LvUploadImgBtn
        isTextBtn
        :big="big"
        :oneFile="oneFile"
        :uploadText="uploadText"
        :remindText="remindText"
        :leadingIcon="leadingIcon"
        :uploadModule="uploadModule"
        :selectedFileList="images"
        @input="$_onAttachImgs($event)"
      />
    </div>
    <div v-if="images.length > 0" class="lv-upload-img-list__content">
      <LvImgPreviewBtn
        v-for="(imageItem, imageIndex) in images"
        :key="imageIndex"
        upload
        showDeleteBtn
        :small="small"
        :medium="medium"
        :num="imageIndex"
        :id="imageItem.id"
        :url="imageItem.url"
        :name="imageItem.name"
        :module="uploadModule"
        :hasScope="imageItem.hasScope"
        :isSystem="imageItem.isSystem"
        :isLoading="imageItem.isLoading"
        :showMoreBtn="imageItem.showMoreBtn"
        :showDownloadBtn="imageItem.showDownloadBtn"
        class="ma-4"
        @remove="$_onRemoveImg(imageIndex)"
        @go-to="$emit('go-to', $event)"
      />
    </div>
    <div v-if="errors.length > 0" class="lv-upload-img-list__invalid">
      <i class="icon-warning lv-upload-img-list__invalid-icon" />
      <LvText v-for="(text_e, text_k) in errors" :key="text_k" red remark class="ml-4">{{
        $t(text_e)
      }}</LvText>
    </div>
  </ValidationProvider>
</template>
<script>
import { extend } from 'vee-validate';
import { ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '此項目為必填',
});

export default {
  components: {
    ValidationProvider,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    rules: {
      type: String,
    },
    uploadModule: {
      type: String,
    },
    remindText: {
      type: String,
    },
    uploadText: {
      type: String,
    },
    oneFile: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
    },
    big: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      images: [],
    };
  },
  watch: {
    images() {
      this.$emit('input', this.images);
    },
    value() {
      this.images = this.value;
    },
  },
  mounted() {
    this.images = this.value;
  },
  methods: {
    $_onRemoveImg(index) {
      this.images.splice(index, 1);
    },
    $_onAttachImgs($event) {
      this.images = this.images.concat($event);
    },
  },
};
</script>
